// Where to send the user right after a MyBestUser sign-in.
//
// Two kinds of saved URL reach the sign-in page:
// - `tabletReturnPath` (localStorage): written by the tablet logout button so
//   the same person lands back on the page they left. It is only trusted for an
//   account of the same role — a different role on a shared tablet would be
//   dropped onto a page of the previous account's role (e.g. a teacher-only
//   class health check run), so that role's home is used instead.
// - `previousURL` (sessionStorage): a direct link opened before signing in. Its
//   role segment is swapped for the signed-in role on purpose: a teacher who
//   opens a link shared from a student tablet gets the teacher version of it
//   (2025-12-16, #192).

const ROLE_ROUTES = ["admin", "teacher", "student"];

export const resolveLoginRedirect = ({
  previousUrl,
  fromLogout = false,
  userRoleRoute
}) => {
  const home = `/${userRoleRoute}`;
  if (!previousUrl) return home;

  const pathSegments = previousUrl.split("/").filter(Boolean);
  if (pathSegments.length === 0) return previousUrl;

  const firstSegment = pathSegments[0];
  if (!ROLE_ROUTES.includes(firstSegment)) return previousUrl;

  if (firstSegment === userRoleRoute) return previousUrl;
  if (fromLogout) return home;

  pathSegments[0] = userRoleRoute;
  return "/" + pathSegments.join("/");
};
